import { PrevModule } from "../reducers/prevModelReducer";

// prevModelAction.ts
export const ADD_PREV_MODEL = 'ADD_PREV_MODEL';

interface AddPrevModelAction {
  type: typeof ADD_PREV_MODEL;
  payload: PrevModule; // Use 'Module' type directly
}

export interface selectedTabeModule {
  ModuleID: any;
  ModuleName: string;
  // Add other properties as needed
}

export type PrevModelAction = AddPrevModelAction;

export const addPrevModel = (prevModel: PrevModule): AddPrevModelAction => ({
  type: ADD_PREV_MODEL,
  payload: prevModel,
});
